// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2R1ed","footer":"ModalCreateQualiphyProcedure_footer__3SBrm","additionData":"ModalCreateQualiphyProcedure_additionData__3m9pA"};